/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/



import {Notify,Loading} from 'quasar'



export default { config: {"brand":{"primary_2":"#606060","primary_text":"#232323","light_accent":"#fbe5a6","dark_primary":"#423e3f"}},plugins: {Notify,Loading} }

